import { render, staticRenderFns } from "./EmbeddedScopeError.vue?vue&type=template&id=71c0b822&lang=pug"
import script from "./EmbeddedScopeError.vue?vue&type=script&lang=js"
export * from "./EmbeddedScopeError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports